module.exports = __webpack_public_path__ + "static/media/moduleSet_i3o1.21c59ebe.jpg";